import Chart, { formatAmount, withUnit } from './Chart';

// §2.6 (rev 2.3) ShareRing: who (or which client) the range's output came from. Five slices at most (the API sends the
// top 4 and "Other"), in the accent's ladder (full, 70, 45, 25%; the fifth in border-strong), a 2 px canvas gap between
// slices, direct labels beside the ring (name and share). Each slice has a title tooltip.
//   slices: [{ id, name, amount, share }] largest first; unit 'words' | 'min'.
const R = 56, r = 34, C = 60;
function arc(a0, a1) {
  if (a1 - a0 >= Math.PI * 2 - 1e-6) a1 = a0 + Math.PI * 2 - 1e-4;   // one slice: a full ring, drawn just short of closing
  const large = a1 - a0 > Math.PI ? 1 : 0;
  const p = (rad, a) => `${C + rad * Math.cos(a)},${C + rad * Math.sin(a)}`;
  return `M${p(R, a0)} A${R},${R} 0 ${large} 1 ${p(R, a1)} L${p(r, a1)} A${r},${r} 0 ${large} 0 ${p(r, a0)} Z`;
}
const pct = s => `${Math.round(s * 100)}%`;

export default function ShareRing({ title, note, slices, unit = 'words' }) {
  const parts = slices.slice(0, 5);
  let a = -Math.PI / 2;
  const total = parts.reduce((s, p) => s + p.amount, 0);
  const table = {
    columns: [
      { key: 'name', label: 'Name' },
      { key: 'amount', label: 'Approved', align: 'right', render: x => <span className="ui-num">{formatAmount(x.amount, unit)}</span> },
      { key: 'share', label: 'Share', align: 'right', render: x => <span className="ui-num">{pct(x.share)}</span> },
    ],
    rows: parts, rowKey: x => x.id || x.name,
  };
  return (
    <Chart title={title} note={note} table={table} className="ui-share">
      <div className="ui-share__body">
        <svg width="120" height="120" viewBox="0 0 120 120" role="img" aria-label={`${title}: ${parts.map(p => `${p.name} ${pct(p.share)}`).join(', ')}.`}>
          {parts.map((p, i) => {
            const a0 = a; a += (total ? p.amount / total : 0) * Math.PI * 2;
            return <path key={p.id || p.name} className={`ui-share__slice ui-share__slice--${i + 1}`} d={arc(a0, a)}><title>{`${p.name}: ${withUnit(p.amount, unit)}, ${pct(p.share)}`}</title></path>;
          })}
        </svg>
        <ol className="ui-share__list">
          {parts.map((p, i) => (
            <li key={p.id || p.name}><i className={`ui-share__key ui-share__slice--${i + 1}`} aria-hidden="true" /><span className="ui-truncate" title={p.name}>{p.name}</span><b className="ui-num">{pct(p.share)}</b></li>
          ))}
        </ol>
      </div>
    </Chart>
  );
}
